<template>
	<div
		class="flex align-center rounded-lg bg-white shadow mb-5"
		data-testid="title-bar-wrapper">
		<div
			class="w-full flex justify-between gap-4 px-4 py-4 sm:px-5"
			:class="classes"
			data-testid="title-bar">
			<div class="flex gap-4 items-center lg:mr-10 sm:shrink-0">
				<div v-if="$slots.icon" class="flex flex-1">
					<slot name="icon"></slot>
				</div>
				<app-icon
					v-if="!$slots.icon && icon"
					:icon="icon"
					class="text-4xl md:text-5xl text-mabey-950"
					data-testid="icon" />
				<div>
					<h3 v-if="subtitle" class="text-sm" data-testid="subtitle">{{ subtitle }}</h3>
					<h1 class="text-md md:text-xl font-bold" data-testid="title">{{ title }}</h1>
				</div>
			</div>

			<div v-if="badges" class="flex gap-3">
				<div v-for="(badge, index) in badges" :key="index">
					<app-badge
						v-if="badge && badge != ''"
						size="medium"
						theme="outline"
						data-testid="badge">
						{{ badge }}
					</app-badge>
				</div>
			</div>

			<div
				data-testid="content"
				class="flex grow-0 shrink-1"
				:class="
					mobile
						? 'text-end justify-end'
						: props.badges
							? 'xl:justify-end xl:text-right'
							: 'lg:justify-end lg:text-right'
				">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { computed } from 'vue'

	const props = withDefaults(
		defineProps<{
			title: string
			subtitle?: string
			icon?: Array<string>
			badges?: string[]
			mobile?: boolean
		}>(),
		{
			subtitle: undefined,
			icon: undefined,
			badges: undefined
		}
	)

	const classes = computed(() => ({
		'items-center': props.mobile,
		'flex-col xl:flex-row xl:items-center': !props.mobile && props.badges,
		'flex-col lg:flex-row lg:items-center': !props.mobile && !props.badges
	}))
</script>
